import { Component, ViewContainerRef, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ConfigGroupService } from './group.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'configure-group',
  templateUrl: './configure_group.component.html',
  styleUrls: ['./configSection.css']
})
export class ConfigureGroupComponent {
  @ViewChildren('input') vc;


  paySlipIdResult = [];
  fieldTypes = [];

  Groups = ["Arun", "Gaurav", "Aman", "Mohit"];
  SelectedGroups = [];
  groupsModel = '';
  SelectedgroupModel = '';


  Tabs = ["Tab1", "Tab2", "Tab3", "Tab4"];
  SelectedTabs = [];
  tabModel = '';
  SelectedTabModel = '';

  groupName = '';
  groupNameSearch: any;
  groupKey = '';
  groupIdentifier = '';
  groupGUID = '';
  GroupExist = false;
  SelectedId = '';
  DefaultValue = '';
  public searchFieldGroup;
  public searchSelectedFieldValue;
  public searchSelectedSectionValue;
  public searchSectionGroup;
  public originalFieldsArray;
  public originalSectionsArray;
  public originalSelectedFieldArray;
  public originalSelectedSectionArray;

  collectionDetails = [];
  searchDataPafing = [];
  indexStart = 0;
  indexEnd = 10;
  pageSize = 4;
  pageNo = 1;
  totalPage = [1];

  buttonType = "Save";
  showEdit = false;
  fieldSearchDisabled = true;
  sectionSearchDisabled = true;
  showAdd = false

  constructor(
    public toastr: ToastsManager, vcr: ViewContainerRef,
    private sectionService: ConfigGroupService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.toastr.setRootViewContainerRef(vcr);
	this.originalFieldsArray = [];
	this.originalSectionsArray = [];
	this.originalSelectedFieldArray = [];
	this.originalSelectedSectionArray = [];
    //this.paySlipIdResult = [{ "payInSlipCode": "20000000", "cmsPayInSlipNo": "77889944", "id": "39dec0b43eb199512f7c216c3cbac4ec" }, { "payInSlipCode": "20000001", "cmsPayInSlipNo": "54545454", "id": "39dec1be0daf9960a310b500ea6ed200" }, { "payInSlipCode": "20000002", "cmsPayInSlipNo": "521212", "id": "39dec1c6d4cb40fe618dc07bd81dfab8" }, { "payInSlipCode": "20000004", "cmsPayInSlipNo": "1215454", "id": "39dec5827dfa0c343004ec6ff0f3a292" }, { "payInSlipCode": "20000005", "cmsPayInSlipNo": "sdgyg154", "id": "39df0834feac608c905d2056c64b2a84" }, { "payInSlipCode": "20000006", "cmsPayInSlipNo": "5454578", "id": "39df083b7b8a0c4c6f19f0da1a517252" }, { "payInSlipCode": "20000007", "cmsPayInSlipNo": "4512654", "id": "39df40a7b7ea5c88d4bb65c1f2db2630" }, { "payInSlipCode": "20000008", "cmsPayInSlipNo": "1212121545", "id": "39df40ce00d411644cffd0974b7f5908" }, { "payInSlipCode": "20000009", "cmsPayInSlipNo": "12345", "id": "39df4b61d9bb6b10729c256dc2c6eabf" }, { "payInSlipCode": "20000011", "cmsPayInSlipNo": "123456", "id": "39df4bee8e5614422b419bc8dbc51480" }, { "payInSlipCode": "20000057", "cmsPayInSlipNo": "215445455", "id": "39df99944fec4f1793e1baa6dfa01c9a" }, { "payInSlipCode": "20000058", "cmsPayInSlipNo": "254545445", "id": "39dfb35ea8a8517e7130268e575a60fb" }, { "payInSlipCode": "20000059", "cmsPayInSlipNo": "5421545444", "id": "39dfb891dc194a39587944e8a4c7d752" }, { "payInSlipCode": "20000061", "cmsPayInSlipNo": "456987123", "id": "39dfbdc269db9286e9d2782c33cda6b6" }, { "payInSlipCode": "20000068", "cmsPayInSlipNo": "456987321", "id": "39dfbdfc3d7fe9b81138bde86fc9b485" }, { "payInSlipCode": "20000069", "cmsPayInSlipNo": "54545454545", "id": "39dfc17f7f83476496a18d5e57f35306" }, { "payInSlipCode": "20000070", "cmsPayInSlipNo": "78965412", "id": "39dfc2b16565da74162fbc73a60425a8" }, { "payInSlipCode": "20000071", "cmsPayInSlipNo": "456123", "id": "39dfc2b7f99b20f9c1997f20dfc9f09a" }, { "payInSlipCode": "20000072", "cmsPayInSlipNo": "789654", "id": "39dfd625bb8438443c4d2192ef0cb193" }, { "payInSlipCode": "20000073", "cmsPayInSlipNo": "123456456", "id": "39dfd62889127e0052d85f29e03b82f8" }, { "payInSlipCode": "20000076", "cmsPayInSlipNo": "1224145454541212", "id": "39dfdbb42192f1657de5bf2a90217bd9" }, { "payInSlipCode": "20000077", "cmsPayInSlipNo": "1224145454541221", "id": "39dfdbbb14cef6a7aa1d25b1889156aa" }];
    this.fieldTypes = ["Alphabets", "Numeric", "string", "Date", "Time", "Drop down and master driven", "Auto predictive text and master driven", "Fixed dropdown Values", "Radio button", "Email", "Checkbox", "computated", "Autopopulate"]

    this.sectionService
      .GetGroups()
      .subscribe(collectorObj => {
        this.paySlipIdResult = collectorObj;

        this.collectionDetails = [];
        this.searchDataPafing = [];
        this.collectionDetails = collectorObj;
        if (this.collectionDetails.length > 5) {
          let j = 1;
          for (var i = 0; i < this.collectionDetails.length; i++) {
            i = i + this.pageSize;
            j = j + 1;
            this.totalPage.push(j);
          }
        }
        for (var i = 0; i < this.collectionDetails.length; i++) {
          let arr = [];
          arr = this.collectionDetails[i];
          let rowNum = i;
          this.searchDataPafing.push({ arr, "row": rowNum });
        }
        this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
        this.indexEnd = (this.pageNo * this.pageSize);
      });

    this.sectionService
      .GetFields()
      .subscribe(collectorObj => {
        this.Groups = collectorObj;
        this.originalFieldsArray = collectorObj;
      });

    this.sectionService
      .GetSections()
      .subscribe(collectorObj => {
        this.Tabs = collectorObj;
        this.originalSectionsArray = collectorObj;
		console.log(this.originalSectionsArray);
      });


  }


  pagingAgent(data) {
    this.pageNo = data;
    this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
    this.indexEnd = (this.pageNo) * this.pageSize;
  }

  changeItemsPerPage(data) {
    if (this.collectionDetails.length > 0) {
      this.totalPage = [1]
      let j = 1;
      for (var i = 0; i < this.collectionDetails.length; i++) {
        i = i + this.pageSize;
        j = j + 1;
        this.totalPage.push(j);
      }
    }
    else {
      this.totalPage = [];
    }
    this.pageSize = data;
    this.indexStart = 0;
    this.indexEnd = this.pageSize;
  }



  moveRight() {
    for (var i = 0; i < this.groupsModel.length; i++) {
      this.SelectedGroups.push(this.groupsModel[i]);
      for (var j = this.Groups.length - 1; j >= 0; j--) {
        if (this.Groups[j] === this.groupsModel[i]) {
          this.Groups.splice(j, 1);
        }
      }
    }
    this.groupsModel = '';
	if(this.SelectedGroups.length>0){
		this.fieldSearchDisabled = false;
		this.originalSelectedFieldArray = this.SelectedGroups;
	}else{
		this.fieldSearchDisabled = true;
	}
  }
  moveLeft() {
    for (var i = 0; i < this.SelectedgroupModel.length; i++) {
      this.Groups.push(this.SelectedgroupModel[i]);
      for (var j = this.SelectedGroups.length - 1; j >= 0; j--) {
        if (this.SelectedGroups[j] === this.SelectedgroupModel[i]) {
          this.SelectedGroups.splice(j, 1);
        }
      }
    }
    this.SelectedgroupModel = '';
	if(this.SelectedGroups.length>0){
		this.fieldSearchDisabled = false;
		this.originalSelectedFieldArray = this.SelectedGroups;
	}else{
		this.fieldSearchDisabled = true;
	}
  }

  moveAllRight() {
    for (var i = 0; i < this.SelectedGroups.length; i++) {
      this.Groups.push(this.SelectedGroups[i]);
    }
    this.SelectedGroups = this.Groups;
    this.Groups = [];
	if(this.SelectedGroups.length>0){
		this.fieldSearchDisabled = false;
		this.originalSelectedFieldArray = this.SelectedGroups;
	}
  }
  moveAllLeft() {
    for (var i = 0; i < this.Groups.length; i++) {
      this.SelectedGroups.push(this.Groups[i]);
    }
    this.Groups = this.SelectedGroups;
    this.SelectedGroups = [];
	if(this.SelectedGroups.length>0){
		this.fieldSearchDisabled = false;
		this.originalSelectedFieldArray = this.SelectedGroups;
	}else{
		this.fieldSearchDisabled = true;
	}
  }


  moveRightTab() {
    for (var i = 0; i < this.tabModel.length; i++) {
      this.SelectedTabs.push(this.tabModel[i]);
      for (var j = this.Tabs.length - 1; j >= 0; j--) {
        if (this.Tabs[j] === this.tabModel[i]) {
          this.Tabs.splice(j, 1);
        }
      }
    }
    this.tabModel = '';
	if(this.SelectedTabs.length>0){
		this.sectionSearchDisabled = false;
		this.originalSelectedSectionArray = this.SelectedTabs;
	}
  }

  moveLeftTab() {
    for (var i = 0; i < this.SelectedTabModel.length; i++) {
      this.Tabs.push(this.SelectedTabModel[i]);
      for (var j = this.SelectedTabs.length - 1; j >= 0; j--) {
        if (this.SelectedTabs[j] === this.SelectedTabModel[i]) {
          this.SelectedTabs.splice(j, 1);
        }
      }
    }
    this.SelectedTabModel = '';
	if(this.SelectedTabs.length>0){
		this.sectionSearchDisabled = false;
		this.originalSelectedSectionArray = this.SelectedTabs;
	}else{
		this.sectionSearchDisabled = true;
	}
  }

  moveAllRightTab() {
    for (var i = 0; i < this.SelectedTabs.length; i++) {
      this.Tabs.push(this.SelectedTabs[i]);
    }
    this.SelectedTabs = this.Tabs;
    this.Tabs = [];
	if(this.SelectedTabs.length>0){
		this.sectionSearchDisabled = false;
		this.originalSelectedSectionArray = this.SelectedTabs;
	}
  }

  moveAllLeftTab() {
    for (var i = 0; i < this.Tabs.length; i++) {
      this.SelectedTabs.push(this.Tabs[i]);
    }
    this.Tabs = this.SelectedTabs;
    this.SelectedTabs = [];
	if(this.SelectedTabs.length>0){
		this.sectionSearchDisabled = false;
		this.originalSelectedSectionArray = this.SelectedTabs;
	}else{
		this.sectionSearchDisabled = true;
	}
  }


  // typeHead Scr=tion Start
  nameInputFormatter = (result: { name: string }) => result.name


  formatter = (result: { name: string }) => result.name

  searchByCode = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.paySlipIdResult.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  // typeHead Scr=tion End
	 
  
  ConfigFieldSubmit(configForm) {
    let postSelectedFields = [];
    for (var i = 0; i < this.SelectedGroups.length; i++) {
      postSelectedFields.push({ "Id": this.SelectedGroups[i]["id"] });
    }
    let postSelectedSections = [];
    for (var i = 0; i < this.SelectedTabs.length; i++) {
      postSelectedSections.push({ "Id": this.SelectedTabs[i]["id"] });
    }
    if (this.SelectedId != "") {
      let data = {
        "Fields": postSelectedFields,
        "Key": this.camelize(this.groupName),
        "Id": this.SelectedId,//this.groupGUID,
        "GroupName": this.groupName,
        "Sections": postSelectedSections
      }
      this.sectionService
        .EditGroup(data)
        .subscribe(collectorObj => {
          if (collectorObj == 'Success') {
            this.toastr.success('Group edited successfully.');
            this.SelectedId = '';
            configForm.reset();
			 setTimeout(()=>{  
				 this.sectionService
				  .GetGroups()
				  .subscribe(collectorObj => {
					this.paySlipIdResult = collectorObj;

					this.collectionDetails = [];
					this.searchDataPafing = [];
					this.collectionDetails = collectorObj;
					if (this.collectionDetails.length > 5) {
					  let j = 1;
					  for (var i = 0; i < this.collectionDetails.length; i++) {
						i = i + this.pageSize;
						j = j + 1;
						this.totalPage.push(j);
					  }
					}
					for (var i = 0; i < this.collectionDetails.length; i++) {
					  let arr = [];
					  arr = this.collectionDetails[i];
					  let rowNum = i;
					  this.searchDataPafing.push({ arr, "row": rowNum });
					}
					this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
					this.indexEnd = (this.pageNo * this.pageSize);
				  });
				}, 5000);		
          }
          else {
            this.toastr.error('some error occured.');
          }
		  
          //this.Groups = collectorObj;
        });
		
    }
    else {

      let data = {
        "Fields": postSelectedFields,
        "Key": this.camelize(this.groupName),
        "GroupName": this.groupName,
        "Sections": postSelectedSections
      }
     this.sectionService
        .AddGroup(data)
        .subscribe(collectorObj => {
          if (collectorObj == 'Success') {

            this.toastr.success('Group added successfully.');
            this.SelectedId = '';
            configForm.reset();
			setTimeout(()=>{  
				 this.sectionService
				  .GetGroups()
				  .subscribe(collectorObj => {
					this.paySlipIdResult = collectorObj;

					this.collectionDetails = [];
					this.searchDataPafing = [];
					this.collectionDetails = collectorObj;
					if (this.collectionDetails.length > 5) {
					  let j = 1;
					  for (var i = 0; i < this.collectionDetails.length; i++) {
						i = i + this.pageSize;
						j = j + 1;
						this.totalPage.push(j);
					  }
					}
					for (var i = 0; i < this.collectionDetails.length; i++) {
					  let arr = [];
					  arr = this.collectionDetails[i];
					  let rowNum = i;
					  this.searchDataPafing.push({ arr, "row": rowNum });
					}
					this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
					this.indexEnd = (this.pageNo * this.pageSize);
				  });
				}, 5000);
          }
          else {
            this.toastr.error('some error occured.');
          }
          //this.Groups = collectorObj;
        });
    }

	
  }
  
  camelize = (str: string) => {
    return str
      .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
      .replace(/\s/g, '')
      .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
  }

  selected = (event) => {
    this.showEdit = true
    this.showAdd = false
    console.log(this.groupNameSearch)
    this.groupIdentifier = this.groupNameSearch.name;
    this.groupName = this.groupNameSearch.name;
    this.GroupExist = false;
    for (var i = 0; i < this.paySlipIdResult.length; i++) {
      if (this.paySlipIdResult[i]["name"] == this.groupNameSearch.name) {
        this.GroupExist = true;
        this.SelectedId = this.paySlipIdResult[i]["id"];
        setTimeout(() => {    //<<<---    using ()=> syntax
          this.GroupExist = false;
        }, 3000);
      }
    }
    if (this.GroupExist) {
      this.sectionService
        .GetGroupById(this.SelectedId)
        .subscribe(collectorObj => {
          for (var i = 0; i < collectorObj["fields"].length; i++) {
			console.log(collectorObj["fields"][i]);
            for (var j = 0; j < this.Groups.length; j++) {
              if (this.Groups[j]["id"] == collectorObj["fields"][i]) {
                this.SelectedGroups.push(this.Groups[j]);
                this.Groups.splice(j, 1);
              }
            }
          }
	
          for (var i = 0; i < collectorObj["sections"].length; i++) {
            for (var j = 0; j < this.Tabs.length; j++) {
              if (this.Tabs[j]["id"] == collectorObj["sections"][i]) {
                this.SelectedTabs.push(this.Tabs[j]);
                this.Tabs.splice(j, 1);
              }
            }
          }
			if(this.SelectedGroups.length>0){
				this.fieldSearchDisabled = false;
				this.originalSelectedFieldArray = this.SelectedGroups;
			}
			if(this.SelectedTabs.length>0){
				this.sectionSearchDisabled = false;
				this.originalSelectedSectionArray = this.SelectedTabs;
			}
        });
    }
  }

  RowSelected = (event) => {
    this.groupIdentifier = event;
    this.buttonType = "Update";
    for (var i = 0; i < this.paySlipIdResult.length; i++) {
      if (this.paySlipIdResult[i]["name"] == event) {
        this.groupName = this.paySlipIdResult[i];
        this.SelectedId = this.paySlipIdResult[i]["id"];

      }
    }

    this.sectionService
      .GetGroupById(this.SelectedId)
      .subscribe(collectorObj => {
        for (var i = 0; i < collectorObj["fields"].length; i++) {
          for (var j = 0; j < this.Groups.length; j++) {
            if (this.Groups[j]["id"] == collectorObj["fields"][i]) {
              this.SelectedGroups.push(this.Groups[j]);
              this.Groups.splice(j, 1);
            }
          }
        }

        for (var i = 0; i < collectorObj["sections"].length; i++) {
          for (var j = 0; j < this.Tabs.length; j++) {
            if (this.Tabs[j]["id"] == collectorObj["sections"][i]) {
              this.SelectedTabs.push(this.Tabs[j]);
              this.Tabs.splice(j, 1);
            }
          }
        }

      });

  }

  groupNameBlur = (event) => {
    this.groupIdentifier = event.target.value;
  }

  addNew() {
	this.groupNameSearch = '';
	this.groupName = '';
	this.SelectedGroups = [];
	this.SelectedTabs = [];
	this.SelectedId = '';
	this.sectionService
      .GetFields()
      .subscribe(collectorObj => {
        this.Groups = collectorObj;
      });

    this.sectionService
      .GetSections()
      .subscribe(collectorObj => {
        this.Tabs = collectorObj;
      });
    this.showEdit = false
    this.showAdd = true
  }
	
 searchFields(){
		let searchData = this.searchFieldGroup;
		let searchResult = [];
		this.Groups = this.originalFieldsArray;
		if(searchData){
			for(let i=0; i<this.Groups.length;i++){
				if (this.Groups[i]['name'].toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.Groups[i]);
				}
			}
			this.Groups=[];
			this.Groups= searchResult;
		}else{
			this.Groups = this.originalFieldsArray;
		}
	}
	searchSections(){
		let searchData = this.searchSectionGroup;
		let searchResult = [];
		this.Tabs = this.originalSectionsArray;
		if(searchData){
			for(let i=0; i<this.Tabs.length;i++){
				if (this.Tabs[i]['name'].toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.Tabs[i]);
				}
			}
			this.Tabs=[];
			this.Tabs= searchResult;
		}else{
			this.Tabs = this.originalSectionsArray;
		}
	}
	searchSelectedFields(){
		let searchData = this.searchSelectedFieldValue;
		let searchResult = [];
		this.SelectedGroups = this.originalSelectedFieldArray;
		if(searchData){
			for(let i=0; i<this.SelectedGroups.length;i++){
				if (this.SelectedGroups[i]['name'].toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.SelectedGroups[i]);
				}
			}
			this.SelectedGroups=[];
			this.SelectedGroups= searchResult;
		}else{
			this.SelectedGroups = this.originalSelectedFieldArray;
		}
	}
	searchSelectedSections(){
		let searchData = this.searchSelectedSectionValue;
		let searchResult = [];
		this.SelectedTabs = this.originalSelectedSectionArray;
		if(searchData){
			for(let i=0; i<this.SelectedTabs.length;i++){
				if (this.SelectedTabs[i]['name'].toLowerCase().indexOf(searchData.toLowerCase()) != -1) {
					searchResult.push(this.SelectedTabs[i]);
				}
			}
			this.SelectedTabs=[];
			this.SelectedTabs= searchResult;
		}else{
			this.SelectedTabs = this.originalSelectedSectionArray;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/configur_group/configure_group.component.ts